class OTFAdminPageDetail {
    constructor() {
        //this.initTabSettings();
        // this.formatPrice();
        this.initPageLayout();
        this.initFooterLayout();
        $('.otf-customize-slider .otf-slider').each((index, element) => {
            this.initSlider(element);
        })
    }

    initPageLayout() {
        let $container = $('[otf-page-layout]');
        $container.find('li').on('click', function () {
            $container.find('li').removeClass('active');
            let value = $(this).addClass('active').find('img').attr('alt');
            $container.prev().val(value);
        });
    }

    initFooterLayout() {
        let $container = $('.opal-control-footer');
        $container.find('.footer-select').on('change', function () {
            let value = $container.find('option:selected').val();
            $container.find('.image-select-tpl').removeClass('active');
            $container.find('.image-select [data-value=' +value+']').addClass('active');
            $container.prev().val(value);
        });
    }

    formatPrice() {
        $('[format-price="true"]', '#opaltab-customfield').each((index, element) => {
            $(element).val(OREAdminFunctionJs.formatPrice(Number($(element).val().trim().replace(/[^\d]*/g, ''))));
            $(element).on('keyup', (event) => {
                $(event.currentTarget).val(OREAdminFunctionJs.formatPrice(Number(event.target.value.trim().replace(/[^\d]*/g, ''))))
            });
        })
    }

    initTabSettings() {
        let listElement = [];
        $('#postbox-container-2 [id^="osf_page_"].postbox').each((index, element) => {
            listElement.push(element);
        });
        this._renderTabHtml(listElement);
        this._tabAction();
        // setup Map
    }

    initSlider(element) {
        let $slider = $(element);
        let id = $slider.data('id');
        let unit = $slider.data('unit') ? $slider.data('unit') : '';
        $slider.slider({
            range : "min",
            min   : $slider.data('min'),
            max   : $slider.data('max'),
            step  : $slider.data('step'),
            value : $slider.data('value'),
            create: function (event, ui) {
                $slider.children('.ui-slider-handle').html(`<span>${$slider.slider('value')}${unit}</span>`);
            },
            slide : function (event, ui) {
                $slider.children('.ui-slider-handle').html(`<span>${ui.value}${unit}</span>`);
                $('#' + id).val(ui.value);
            },
            change: function (event, ui) {
                $(ui.handle).closest('.cmb2-slider-element').find('[opal-hidden="true"]').val(ui.value);
            }
        });
        $slider.next().on('click', function () {
            $slider.slider('value', $slider.data('default-value'));
        })
    }

    _renderTabHtml(listElement) {
        let html = `
<section id="opaltab-customfield">
    <h2 class="opaltab-heading"><span>Page Settings</span></h2>
    <div class="opal-customfield-tabs tabs-style-bar">
        <nav class="opal-nav">
            <ul>`;
        for (let element of listElement) {
            let _id = '#tab-section-' + $(element).attr('id');
            let _icon = $(`label[for="${$(element).attr('id')}-hide"] [class*="icon-"]`);
            _icon = _icon.length > 0 ? `<i class="${_icon.attr('class')}"></i>` : '';
            let _title = $('>h2', element).text();
            html += `
                <li>
                    <a href="${_id}">
                        ${_icon}
                        <span>${_title}</span>
                    </a>
                </li>`
        }
        html += `
            </ul>
        </nav>
        <div class="opal-content-wrap content-wrap">`;
        let count = 1;
        for (let element of listElement) {
            let id = 'tab-section-' + $(element).attr('id');
            html += `<section id="${id}"></section>`;
            count++;
        }
        html += `
        </div>
    </div>
</section>`;
        $('#postbox-container-2').before(html);
        for (let element of listElement) {
            $('>.inside', element).appendTo('#tab-section-' + $(element).attr('id'));
            $(element).hide();
        }
    }

    _tabAction() {
        $('#opaltab-customfield .opal-nav ul li:first-child').addClass('tab-current');
        $('#opaltab-customfield .opal-content-wrap > section:first-child').addClass('content-current');
        $('#opaltab-customfield .opal-nav li a').on('click', (event) => {
            event.preventDefault();
            $('#opaltab-customfield .opal-nav li').removeClass('tab-current');
            $(event.currentTarget).parent().addClass('tab-current');
            let id = $(event.currentTarget).attr('href');
            $('#opaltab-customfield .opal-content-wrap > section').removeClass('content-current');
            $(id).addClass('content-current');
        })
    }
}

class OTFdminSwitchOnOffJs {
    classmap = null;

    constructor(maps) {
        this.classmap = maps;
        this.init();
    }

    init() {
        $('.opal-onoffswitch-wrapper').each((index, element) => {
            let $input   = $('input.onoffswitch-input', element);
            let $switch  = $('.onoffswitch-checkbox', element);
            let selector = this.getSelectorString($switch);
            this.actionShowHide(selector, $switch.prop('checked'), 0);
            $switch.on('change', () => {
                this.actionShowHide(selector, $switch.prop('checked'));
                if ($switch.prop('checked')) {
                    $input.val('1');
                } else {
                    $input.val('0');
                }
            })
        })
    }

    actionShowHide(selector, show, duration = 400) {
        if (show) {
            $(selector).stop().slideDown(duration);
        } else {
            $(selector).stop().slideUp(duration);
        }
    }

    getSelectorString($switch) {
        if (typeof $switch.data('show-fields') === 'object') {
            return $switch.data('show-fields').map((field) => {
                return '.cmb2-id-' + field.replace(/_/g, '-');
            }).join(',');
        } else {
            return false;
        }
    }
}

$(document).ready(() => {
    new OTFAdminPageDetail();
    new OTFdminSwitchOnOffJs();
});